import { useContent } from 'contexts/Content/Content';
import { getUrl } from 'helpers';
import {
    Container,
    Content,
    Logo,
    LogoMobile,
    LogoPicture,
    LogoWrap,
    PortionMarking,
    Tagline,
    Text,
    Title,
    Wrap,
} from './Header.styled';

export default function Header({ children, style, visible = true }: HeaderProps) {
    const content = useContent();

    const { background, backgroundMobile, foreground, logo, logoLink, logoMobile, tagline, textOffset, title } =
        content.header;
    const { portionMarking } = content.general;

    return (
        <Wrap style={style}>
            {portionMarking && <PortionMarking>{portionMarking}</PortionMarking>}
            {visible && (
                <Container $background={background} $backgroundMobile={backgroundMobile || background}>
                    <LogoWrap>
                        <a aria-label={`${title} home`} data-testid="header-logo-link" href={logoLink || '/'}>
                            <LogoPicture>
                                <LogoMobile alt={title} src={getUrl(logoMobile || logo)} />
                                <Logo alt={title} src={getUrl(logo)} />
                            </LogoPicture>
                        </a>
                    </LogoWrap>
                    <Content $foreground={foreground}>
                        <Text
                            aria-label={title}
                            data-testid="header-title-link"
                            href={getUrl('/')}
                            $foreground={foreground}
                            $offset={textOffset}
                        >
                            <Title>{title}</Title>
                            {tagline && <Tagline>{tagline}</Tagline>}
                        </Text>
                        {children}
                    </Content>
                </Container>
            )}
        </Wrap>
    );
}
